import type { FC } from "react";
import type { WidgetProps } from "@rjsf/utils";
import KioTextWidget from "@/framework/KioForm/widgets/KioTextWidget";

export const KioTextareaWidget: FC<WidgetProps> = (props) => <KioTextWidget {...props} multiline={true} />;

export default KioTextareaWidget;
